import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import AbstractCmsElement from './AbstractCmsElementNew';


export default class CmsElementDynamicElement extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={'ms_' + this.props.index.toString().replace(/\./g, '_')}
        className={'ms-dyn-el ' + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
      >
        {this.getElementStyle()}

        {this.props.children}

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementDynamicElement.defaultProps = {
  index: '0',
};
